// 全域介面狀態：目前檢視的 Trip、模擬「以哪位成員身分檢視」（用來展示可見性過濾）、
// 以及離線模式模擬（對應規格書 5.10 離線記錄與同步）。
export default {
  namespaced: true,
  state: {
    currentTripId: null,
    viewingAsMemberId: null,
    simulateOffline: false,
    syncQueue: [], // [{ id, summary, createdAt }] 離線時建立、尚未「上傳」的項目
    quickCaptureVisible: false,
    discoveryFlowVisible: false
  },
  mutations: {
    SET_CURRENT_TRIP (state, tripId) {
      state.currentTripId = tripId
    },
    SET_VIEWING_AS (state, memberId) {
      state.viewingAsMemberId = memberId
    },
    SET_OFFLINE (state, value) {
      state.simulateOffline = value
    },
    PUSH_SYNC_ITEM (state, item) {
      state.syncQueue.push(item)
    },
    CLEAR_SYNC_QUEUE (state) {
      state.syncQueue = []
    },
    SET_QUICK_CAPTURE (state, value) {
      state.quickCaptureVisible = value
    },
    SET_DISCOVERY_FLOW (state, value) {
      state.discoveryFlowVisible = value
    }
  },
  actions: {
    enterTrip ({ commit, rootGetters }, tripId) {
      commit('SET_CURRENT_TRIP', tripId)
      const members = rootGetters['members/byTrip'](tripId)
      const owner = members.find(m => m.role === 'owner')
      commit('SET_VIEWING_AS', owner ? owner.id : (members[0] && members[0].id))
    },
    setViewingAs ({ commit }, memberId) {
      commit('SET_VIEWING_AS', memberId)
    },
    toggleOffline ({ commit, state }) {
      commit('SET_OFFLINE', !state.simulateOffline)
    },
    queueForSync ({ commit, state }, summary) {
      if (!state.simulateOffline) return
      commit('PUSH_SYNC_ITEM', { id: `${Date.now()}-${Math.random()}`, summary, createdAt: new Date().toISOString() })
    },
    flushSyncQueue ({ commit }) {
      commit('CLEAR_SYNC_QUEUE')
    }
  }
}
